import { useCallback, useState } from "react";

import { Holding } from "../../../../services/holdings";
import { UseSourceCountryPanelReturn } from "./types";

export const useSourceCountryPanel = (): UseSourceCountryPanelReturn => {
  const [panel, setPanel] = useState<UseSourceCountryPanelReturn["panel"]>({
    isOpen: false,
    holding: null,
  });

  const openPanel = useCallback((holding: Holding) => {
    setPanel({ isOpen: true, holding });
  }, []);

  const closePanel = useCallback(() => {
    setPanel((current) => ({ ...current, isOpen: false }));
  }, []);

  return { panel, openPanel, closePanel };
};
